import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class DevicesRoute extends Route {
  @service features;

  crumb() {
    return {
      name: 'Devices',
      path: this.routeName,
    };
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.prepareDevices();
  }
}
